import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";

export const PROFESSIONAL_ID_TYPES = [
  { id: 1, text: "RPPS" },
  { id: 2, text: "ADELI" },
];

export const getProfessions = (lang: string) => [
  { id: 1, text: T(TKey.PROFESSION_PEDICURE_PODOLOGUE, lang) as string },
  { id: 2, text: T(TKey.PROFESSION_ORTHOPEDISTE_ORTHESISTE, lang) as string },
  { id: 3, text: T(TKey.PROFESSION_PODO_ORTHESISTE, lang) as string },
  { id: 4, text: T(TKey.PROFESSION_ORTHOPROTHESISTE, lang) as string },
];
